import * as React from 'react'
import PropTypes from 'prop-types'
import Section from 'src/components/Section'
import IntroSectionItem, {
  IntroSectionItemType,
} from './IntroSectionItem'

import * as style from './style.module.css'

export default function IntroSection({
  title = 'Intro Section Title',
  items,
}) {
  return (
    <Section withPadding>
      <h2 className={style.title}>{title}</h2>
      <div className={style.items}>
        {items &&
          items.map(item => (
            <IntroSectionItem
              image={item.image}
              title={item.title}
              description={item.description}
              cta={item.cta}
              key={item.title}
            />
          ))}
      </div>
    </Section>
  )
}

IntroSection.defaultProps = {
  title: `Intro Section`,
  items: [
    {
      item: {
        image: {},
        title: 'Item title',
        description: 'Description goes here',
        cta: {
          text: `Learn More`,
          href: '/',
        },
      },
    },
  ],
}

IntroSection.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.exact(IntroSectionItemType)
  ),
}
